<!--Because <progress> elements are hard to style-->

<style>
    .progress-bar {
        background: rgba(127, 127, 127, 0.3);
        border-radius: 0.6em;
        display: block;
        height: 0.7em;
        height: 13px;
        overflow: hidden;
        position: relative;
    }

    .progress-bar[data-size="small"] {
        border-radius: 0;
        height: 0.3em;
    }

    .progress-bar__fill {
        background: var(--highlight, currentColor);
        bottom: 0;
        left: 0;
        position: absolute;
        top: 0;
    }
</style>

<template>
    <span class="progress-bar" :data-size="small ? 'small' : ''">
        <span class="progress-bar__fill" :style="{ width: fillPercent }"></span>
    </span>
</template>

<script>
    export default {
        props: {
            value: [Number, String],
            max: [Number, String],
            small: Boolean,
        },

        computed: {
            fillPercent() {
                return parseFloat((this.value / this.max * 100).toFixed(2)) + '%';
            },
        }
    };
</script>
